module.exports = __webpack_public_path__ + "img/breakfast.b1de8237.jpg";